import { createRouter, createWebHistory } from 'vue-router';
import { trans } from '../../_00_elements/translation';
import Payouts from './payouts/Payouts.vue';
import Subscriptions from './subscriptions/Subscriptions.vue';
import Subscription from './subscriptions/Subscription.vue';
import Invoices from './invoices/Invoices.vue';
import UbiqInvoices from './invoices/UbiqInvoices.vue';
import PaymentAccount from './organization/PaymentAccount.vue';
import Manage from './organization/Manage.vue';
import CreationManager from './subscriptions/Steps/CreationManager.vue';
import {
  URL_BUYER_INVOICES,
  URL_INVOICES,
  URL_MANAGEMENT_INVOICES,
  URL_PAYOUTS,
  URL_SUBSCRIPTION,
  URL_SUBSCRIPTION_CREATE,
  URL_USER_ORGANIZATION_MANAGE,
  URL_USER_ORGANIZATION_PAYMENT_ACCOUNT,
  URL_INVOICING_HEADER_INFOS,
  URL_USER_PROFILE_INVOICE,
  URL_SELLER_ORGANIZATION_MANAGE,
} from '../../_00_elements/tools/routes/routes';
import InvoicesBuyer from './invoices/InvoicesBuyer.vue';
import PaymentMethod from './organization/PaymentMethod.vue';
import ManageInvoicing from './organization/ManageInvoicing.vue';

const routes = [
  {
    path: URL_SUBSCRIPTION,
    name: 'subscriptions',
    component: Subscriptions,
    meta: {
      titleKey: 'gestion.subscription.title',
    },
  },
  {
    path: URL_SUBSCRIPTION_CREATE,
    name: 'subscriptionsCreate',
    component: CreationManager,
    meta: {
      titleKey: 'gestion.subscription.step.0.title',
    },
  },
  {
    path: '/invoicing/subscriptions/:id',
    name: 'subscriptionDetails',
    component: Subscription,
    props: true,
  },
  {
    path: URL_INVOICES,
    name: 'invoices',
    component: Invoices,
    meta: {
      titleKey: 'gestion.invoices.title',
    },
  },
  {
    path: URL_MANAGEMENT_INVOICES,
    name: 'ubiqInvoices',
    component: UbiqInvoices,
    meta: {
      titleKey: 'gestion.ubiq_invoices.pay.list.title',
    },
  },
  {
    path: URL_USER_PROFILE_INVOICE,
    name: 'ubiqAdafInvoices',
    component: UbiqInvoices,
    meta: {
      titleKey: 'gestion.ubiq_invoices.adaf.list.title',
    },
  },
  {
    path: URL_PAYOUTS,
    name: 'payouts',
    component: Payouts,
    meta: {
      titleKey: 'user_menu.payouts',
    },
  },
  {
    path: URL_USER_ORGANIZATION_PAYMENT_ACCOUNT,
    name: 'paymentAccount',
    component: PaymentAccount,
    meta: {
      titleKey: 'organization.settings.payment_account',
    },
  },
  {
    path: URL_USER_ORGANIZATION_MANAGE,
    name: 'organizationManage',
    component: Manage,
    meta: {
      titleKey: 'user_menu.organization',
    },
  },
  {
    path: URL_SELLER_ORGANIZATION_MANAGE,
    name: 'organizationManageSeller',
    component: Manage,
    meta: {
      titleKey: 'user_menu.organization',
    },
  },
  {
    path: URL_INVOICING_HEADER_INFOS,
    name: 'organizationInvoicingManage',
    component: ManageInvoicing,
    meta: {
      titleKey: 'organization.settings.header_invoices',
    },
  },
  {
    path: URL_BUYER_INVOICES,
    name: 'invoicesBuyer',
    component: InvoicesBuyer,
    meta: {
      titleKey: 'user_menu.invoices',
    },
  },
  {
    path: '/organization/payment-method/:type',
    name: 'paymentMethod',
    component: PaymentMethod,
    props: true,
    meta: {
      titleKey: 'user_menu.gestion_parameters',
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  if (to.meta?.titleKey) {
    const key = to.meta?.titleKey;
    document.title = `${trans(key)} - ${window.COMPANY_NAME}`;
  }
});

export default router;
